import React, { useState } from 'react'
import ActionMenu from 'builder/components/ActionMenu'
import { useI18n } from 'builder/hooks/useI18n'
import { DropDownIcon, FilterButton } from './styles'

interface Props {
  selected: string
  onSelect: (value: string) => void
}

const TRANSLATION_KEY = 'builder.job_search.filters.titles.job_location_type'

const LocationType = ({ selected, onSelect }: Props) => {
  const [selectionOpen, setSelectionOpen] = useState(false)
  const { i18n } = useI18n()

  const handleSelection = (value: string) => {
    onSelect(value)
    setTimeout(() => setSelectionOpen(false), 100)
  }

  const toggleSelectionOpen = () => {
    setSelectionOpen(prev => !prev)
  }

  const options = ['any', 'remote', 'onsite', 'hybrid']

  const actions = options.map(option => ({
    value: option,
    text: i18n.t(`${TRANSLATION_KEY}.${option}`),
    onClick: () => handleSelection(option === 'any' ? '' : option),
  }))

  const isFilterActive = !!selected
  const label = actions.find(action => action.value === selected)?.text || actions[0].text

  return (
    <FilterButton onClick={toggleSelectionOpen} selected={isFilterActive}>
      {label}
      <DropDownIcon selected={isFilterActive} />
      {selectionOpen && (
        <ActionMenu
          align="left"
          position="bottom"
          onClose={() => setTimeout(() => setSelectionOpen(false), 50)}
          actions={actions}
        />
      )}
    </FilterButton>
  )
}

export default React.memo(LocationType)
